import React from 'react'

export default props => (
  <svg {...props} fill={props.fill || '#808792'} viewBox="-2 0 20 20">
    <g stroke="none" transform="translate(-924.000000, -418.000000)">
      <g transform="translate(734.000000, -4.000000)">
        <g transform="translate(166.000000, 330.000000)">
          <g transform="translate(0.000000, 74.000000)">
            <g transform="translate(23.000000, 17.000000)">
              <path d="M17.004,17.147 C17.004,17.621 16.631,18.005 16.171,18.005 C15.711,18.005 15.339,17.621 15.339,17.147 C15.339,13.546 12.495,10.617 8.999,10.617 C5.502,10.617 2.658,13.546 2.658,17.147 C2.658,17.621 2.285,18.005 1.825,18.005 C1.365,18.005 0.993,17.621 0.993,17.147 C0.993,13.381 3.46,10.204 6.815,9.221 C5.553,8.448 4.697,7.044 4.697,5.426 C4.697,2.984 6.627,0.996 8.999,0.996 C11.37,0.996 13.299,2.984 13.299,5.426 C13.299,7.044 12.443,8.448 11.182,9.221 C14.537,10.203 17.004,13.381 17.004,17.147 L17.004,17.147 Z M8.999,2.712 C7.545,2.712 6.363,3.929 6.363,5.426 C6.363,6.923 7.545,8.141 8.999,8.141 C10.452,8.141 11.634,6.923 11.634,5.426 C11.634,3.929 10.452,2.712 8.999,2.712 L8.999,2.712 Z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/user.js